import ReactDOM from 'react-dom';
import videojs from 'video.js';
import CloseSettingsMenuButton from './CloseSettingsMenuButton';
import Title from './Title';
const vjsComponent = videojs.getComponent('Component');
class SettingsMenuHeader extends vjsComponent {
    constructor(player, options, closeCallback) {
        super(player, options, closeCallback);
        /* Bind the current class context to the mount method */
        this.mount = this.mount.bind(this);
        player.ready(() => {
            this.addClass('vjs-settings-menu-header');
            this.mount(closeCallback);
        });
        /* Remove React root when component is destroyed */
        this.on('dispose', () => {
            ReactDOM.unmountComponentAtNode(this.el());
        });
    }
    mount(closeCallback) {
        this.addChild(new Title(this.player(), {}, 'Video settings'));
        this.addChild(new CloseSettingsMenuButton(this.player(), {}, () => closeCallback()));
    }
}
export default SettingsMenuHeader;
//# sourceMappingURL=SettingsMenuHeader.js.map